import moment from "moment";
import * as React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Alert from "@mui/material/Alert";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from '@mui/material/Grid';
import { useQuery, useMutation } from "@apollo/client";
import CircularProgress from "@mui/material/CircularProgress";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";

import { GET_FALSE_BREAKOUTS } from "../graphql/false-breakouts";
import config from "../config.json";

export default function FalseBreakouts({ }) {
  const [search, setSearch] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const {
    loading: falseBreakoutsLoading,
    error: falseBreakoutsError,
    data: falseBreakouts,
    refetch: refetchFalseBreakouts,
  } = useQuery(GET_FALSE_BREAKOUTS, {
    pollInterval: 60 * 1000,
    fetchPolicy: "network-only",
    variables: {
      input: { symbol: search },
    },
    onCompleted: () => setIsLoading(false),
  });

  if (falseBreakoutsError) {
    return <div>Error: {falseBreakoutsError.message}</div>;
  }

  console.log(falseBreakouts)


  return (
    <>
      {isLoading && (
        <CircularProgress
          size={24}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
          }}
        />
      )}

      {!isLoading && falseBreakouts && (
        // <div>
        //   {falseBreakouts.map((item, index) => (
        //     <div key={index}>
        //       {Object.entries(item).map(([key, value]) => (
        //         <p key={key}>
        //           {key}: {value}
        //         </p>
        //       ))}
        //     </div>
        //   ))}
        // </div>
        <Grid container spacing={3}>
          {falseBreakouts.falseBreakouts.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <div>
                <img src={config.imagesServer + item.plotResultPath}
                  alt={item.coin}
                  style={{
                    width: "95%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                  loading="lazy" />
                <p>Coin: {item.coin}</p>
                <p>Created At: {item.createdAt}</p>
                <p>Frame: {item.frame}</p>
                <p>ID: {item.id}</p>
              </div>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
}
